import { Stack, SxProps, Theme, Typography } from '@mui/material';
import React from 'react';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';
import InformationIcon from '../CustomSVGIcons/InformationIcon';
import { FONT_ENUM } from '../../types/global/fonts.types';

interface IAppWarning {
    message: string;
    sx?: SxProps<Theme>;
}

export const AppWarning: React.FC<IAppWarning> = ({ message, sx }) => {
    const { themeStyle } = useThemeContext();
    return (
        <Stack
            direction="row"
            alignItems="center"
            px={2}
            sx={{
                backgroundColor: theme[themeStyle].deep_grey_lighter,
                borderRadius: 2,
                minHeight: 4,
                border: `0.1px solid ${theme[themeStyle].tag_white}`,
                maxWidth: '100%',
                mb: 2,
                ...sx,
            }}>
            <InformationIcon height={20} width={20} fill={theme[themeStyle].tag_white} />
            <Typography
                sx={{
                    fontFamily: FONT_ENUM.MAIN_MEDIUM,
                    fontSize: 12,
                    color: theme[themeStyle].tag_white,
                    py: '20px',
                    px: '10px',
                    opacity: 0.6,
                }}>
                {message}
            </Typography>
        </Stack>
    );
};
